/* =================== CRIA PAGAMENTO =================== */
jQuery(document).ready(function () {
  // Grava o pagamento
  $(".bt-registrar-pagamento").on("click", function (e) {
    e.preventDefault();
    if ($("#form-pagamento").parsley().validate()) {
      var dados = $("#form-pagamento").serialize();
      $.ajax({
        type: "POST",
        url: $("#form-pagamento").attr("action"),
        data: dados,
        beforeSend: function () {
          showLoading();
        },
        success: function (data) {
          console.log(data);
          data = $.parseJSON(data);
          hideLoading();
          if (data.status_pagamento != 14) {
            location.href =
              url_base +
              "minha-conta/confirmacao/" +
              data.hash +
              "/" +
              data.origem;
          } else {
            showAlert(
              "Erro",
              "Não foi possível completar o pagamento. Por favor, revise os dados e tente novamente.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception, data) {
          hideLoading();
          console.log(data);
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
        },
      });
    }
  });
});
